import {WalletTransferContext} from '#/components/wallet-transfer/wallet-transfer-context';
import {StepHeader, TokenTransferTitleButton} from '#/components/wallet-transfer/wallet-transfer-modal';
import {WalletTransferTab} from '#/components/wallet-transfer/wallet-transfer-tab';
import {getIsAddressValid} from '#/utils/account-utils';
import {CheckCircleIcon} from '@heroicons/react/24/solid';
import {FunctionComponent, useContext, useEffect} from 'react';
import {Title} from 'react-head';
import {useTranslation} from 'react-i18next';

export const WalletTransferStepAccount: FunctionComponent = () => {
  const {setTab, setCompletedTabs, address, setAddress} = useContext(WalletTransferContext);

  const {t} = useTranslation('translation');

  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAddress(event.target.value);
  };

  const hasAddressInput = !!address;
  const isAddressValid = getIsAddressValid(address);

  useEffect(() => {
    if (isAddressValid) {
      setCompletedTabs(prev => {
        if (!prev.includes(WalletTransferTab.ACCOUNT)) {
          return [...prev, WalletTransferTab.ACCOUNT];
        }
        return prev;
      });
    } else {
      setCompletedTabs(prev => prev.filter(val => val !== WalletTransferTab.ACCOUNT));
    }
  }, [setCompletedTabs, setTab, isAddressValid]);

  return (
    <>
      <StepHeader>{t('pages.walletTransfer.sections.accountSelection.header')}</StepHeader>
      <Title>{t('pages.walletTransfer.sections.accountSelection.explanation')}</Title>
      <div className='flex gap-2 items-stretch h-8'>
        <div className='grow flex items-stretch px-2 py-1 gap-2 bg-gray-200 rounded-lg'>
          <input
            className='grow p-0 appearance-none bg-transparent outline-none'
            onChange={onInputChange}
            placeholder={'0x...'}
            value={address}
            type='text'
          />
          <div className='aspect-square flex-center'>
            <CheckCircleIcon
              className={`w-6 h-6 stroke-transparent ${isAddressValid ? 'fill-upgreen' : 'fill-gray-400'}`}
            />
          </div>
        </div>

        {hasAddressInput ? (
          <TokenTransferTitleButton
            className='bg-deepblue text-white w-14'
            onClick={async () => {
              setAddress('');
            }}
          >
            {t('actions.clear')}
          </TokenTransferTitleButton>
        ) : (
          <TokenTransferTitleButton
            className='bg-deepblue text-white w-14'
            onClick={async () => {
              const res = await navigator.clipboard.readText();
              setAddress(res);
            }}
          >
            {t('actions.paste')}
          </TokenTransferTitleButton>
        )}
      </div>
      {!!address && !isAddressValid && (
        <div className='text-downred text-xs font-bold italic mt-1'>
          {t('pages.walletTransfer.sections.accountSelection.enteredInvalidAddress')}
        </div>
      )}

      <div className='grow flex place-items-end'>
        <TokenTransferTitleButton
          className='justify-self-end w-full hover:opacity-70 align-middle py-1 px-2 overflow-hidden text-white text-sm rounded bg-deepblue disabled:bg-gray-400 disabled:opacity-70 relative mt-4'
          onClick={() => {
            setTab(WalletTransferTab.SHARELAND);
          }}
          disabled={!isAddressValid}
        >
          {t('actions.next')}
        </TokenTransferTitleButton>
      </div>
    </>
  );
};
